import { enTranslations } from './translations.en';

export const zhCnTranslations: Record<string, string> = {
  ...enTranslations,
  'nav.overview': '概览',
  'nav.overviewDesc': '运行状态、编排与下发渠道',
  'nav.reception': '前台',
  'nav.receptionDesc': '操作列表、手动发放与批量导入',
  'nav.administration': '管理',
  'nav.administrationDesc': '面向租户、厂商、地点、用户和基础设施的专用列表与表单',
  'shell.consoleTitle': '运营控制台',
  'shell.consoleDescription':
    '面向 PMS 流程、前台操作、网络控制器配置以及 DPSK 分发的多租户控制台。',
  'shell.livePosture': '实时状态',
  'shell.loadingLocation': '正在加载地点上下文',
  'shell.healthy': '运行流程正常',
  'shell.attention': '交付渠道需要关注',
  'shell.authSession': '已认证会话',
  'shell.guestOperator': '演示操作员',
  'shell.noRole': '无角色',
  'shell.currentWorkspace': '当前工作区',
  'shell.workspaceDescription': '当前页面对应的活动上下文。',
  'shell.filters': '筛选',
  'shell.tenant': '租户',
  'shell.location': '酒店 / 地点',
  'shell.language': '语言',
  'shell.theme': '主题',
  'shell.theme.system': '系统',
  'shell.theme.light': '浅色',
  'shell.loadingData': '正在更新数据',
  'shell.searchTenant': '搜索租户',
  'shell.searchLocation': '搜索酒店或地点',
  'shell.noSearchResults': '没有匹配结果',
  'shell.closeFilters': '关闭筛选',
  'dialog.cancel': '取消',
  'dialog.deleteTitle': '确认删除',
  'dialog.extendTitle': '确认延长',
  'dialog.revokeTitle': '确认撤销',
  'shell.noPms': '未关联 PMS',
  'shell.noController': '未关联控制器',
  'shell.tvOn': '电视已启用',
  'shell.tvPending': '电视待启用',
  'shell.emailOn': '邮件已启用',
  'shell.emailPending': '邮件待启用',
  'shell.exitSession': '退出',
  'auth.mode.mock': '演示模式',
  'login.badge': 'Hospitality 运营控制台',
  'login.title': '安全访问 hospitality 平台。',
  'login.description':
    '在一个面向日常运营的统一控制台中管理租户、地点、用户、厂商和 Wi‑Fi 凭证。',
  'login.inputTitle': '租户与地点',
  'login.inputBody': '在同一位置管理资产、单元、厂商和运营配置。',
  'login.logicTitle': '前台与凭证',
  'login.logicBody': '为住客、员工和活动创建、续期并监控 Wi‑Fi 代码，无需额外步骤。',
  'login.outputTitle': '运营可视化',
  'login.outputBody': '快速查看服务状态、队列以及凭证下发情况。',
  'login.accessMode': '登录',
  'login.demoWorkspace': '探索平台',
  'login.keycloakWorkspace': '欢迎回来',
  'login.demoDescription': '打开演示环境，使用示例数据浏览主要流程。',
  'login.keycloakDescription': '使用你的企业账号登录以继续。',
  'login.enterDemo': '打开演示控制台',
  'login.continueKeycloak': '登录平台',
  'login.readyTitle': '集中管理',
  'login.readyBody': '租户、地点、单元、用户和目录都可在同一个运营控制台中使用。',
  'login.supportTitle': '日常操作',
  'login.supportBody': '以前台流程、Wi‑Fi 凭证和服务配置为中心，获得更简洁的操作体验。',
  'login.demoNote': '演示环境使用示例数据，仅用于浏览体验。',
  'login.switchNote': '如果登录遇到问题，请联系服务管理员。',
  'overview.context': '运行概览',
  'overview.title': '所选地点状态',
  'overview.subtitle': '快速查看 DPSK 使用情况、VLAN 映射和站点运行负载。',
  'reception.pageKicker': '前台操作',
  'reception.pageTitle': 'DPSK 发放与生命周期管理',
  'reception.pageDescription': '前台区域分为独立页面：代码列表、手动发放和批量导入。',
  'admin.pageKicker': '管理配置',
  'admin.pageTitle': '租户、厂商、地点和用户',
  'admin.pageDescription': '管理区域包含租户、厂商目录、地点、用户和基础设施的专用页面。',
  'admin.actions.newRoomAssignment': '新建单元',
  'admin.actions.assignRoom': '编辑单元',
  'admin.form.createRoomAssignment': '创建单元',
  'admin.form.updateRoomAssignment': '更新单元',
  'admin.form.roomAssignmentDescription':
    '为单个单元定义 Wi‑Fi 映射。该配置会立即在位置清单和接待流程中生效。',
  'admin.form.roomNotFound': '未找到单元。',
  'admin.form.locationRequiredForRoom': '请先选择一个位置，然后再登记单元。',
  'admin.message.roomAssignmentSaved': '{name} 的基础设施配置已保存。',
  'table.pagination.previous': '上一页',
  'table.pagination.next': '下一页',
  'table.pagination.summary': '{from}-{to} / {total}',
  'app.badge': 'Lumen Hospitality DPSK',
  'auth.mode.keycloak': 'Keycloak',
  'login.realm': 'Realm',
  'login.clientId': 'Client ID',
  'login.endpoint': 'Endpoint',
  'overview.card.active.label': '活动身份',
  'overview.card.active.caption': '当前在所选地点有效的 DPSK',
  'overview.card.scheduled.label': '已计划到达',
  'overview.card.scheduled.caption': '凭证已创建，等待入住或活动开始',
  'overview.card.mapped.label': '已映射单元',
  'overview.card.mapped.caption': '{rooms} 间客房，{publicAreas} 个公共区域，{eventHalls} 个活动大厅',
  'overview.card.daily.label': '日触发量',
  'overview.card.daily.caption': 'PMS、前台和手动请求之间的预期负载',
  'overview.locationHealth': '服务状态',
  'overview.deliveryChannels': '交付渠道',
  'overview.connected': '已连接',
  'overview.fallback': '已启用回退',
  'overview.accounting': 'Accounting',
  'overview.accountingBody': 'RADIUS 日志保持集中管理，用于合规和分析。',
  'overview.operationalFlow': '运营流程',
  'overview.flowAligned': '与文档场景保持一致',
  'overview.channelMix': '渠道构成',
  'overview.distributionSplit': '下发分布',
  'overview.channelShare': '占可见总量的 {share}%',
  'overview.infrastructure': '单元与 VLAN',
  'overview.infrastructureDesc': '该地点可用的客房、公共区域和活动大厅。',
  'overview.alerts': '关注面板',
  'overview.alertsTitle': '当前风险与异常',
  'overview.noAlerts': '当前地点没有未处理异常。',
  'overview.queue': '后台队列',
  'overview.queueTitle': '批量导入状态',
  'overview.queueProgress': '已处理 {processed}/{total}，目标 VLAN 为 {vlan}',
  'overview.credentials': '最近凭证',
  'overview.credentialsTitle': '最近发放的 DPSK',
  'overview.table.guest': '住客',
  'overview.table.space': '单元',
  'overview.table.type': '类型',
  'overview.table.vlan': 'VLAN',
  'overview.table.ssid': 'SSID',
  'overview.table.panMode': 'PAN 模式',
  'overview.table.source': '来源',
  'overview.table.channels': '渠道',
  'overview.table.validity': '有效期',
  'overview.table.devices': '设备',
  'overview.flow.trigger.title': 'PMS / 前台触发',
  'overview.flow.trigger.body': 'Webhook、操作员表单或 CSV 会生成访问请求。',
  'overview.flow.normalize.title': '身份规范化',
  'overview.flow.normalize.body':
    '平台会分配酒店、单元、VLAN 以及有效时间窗口。',
  'overview.flow.provision.title': '网络控制器配置',
  'overview.flow.provision.body':
    'DPSK 会关联到映射的 VLAN 及其生命周期窗口。',
  'overview.flow.deliver.title': '渠道交付',
  'overview.flow.deliver.body': '电视、邮件、控制台或打印渠道接收二维码和密码。',
  'overview.flow.monitor.title': '监控与 Accounting',
  'overview.flow.monitor.body':
    '使用情况、队列、渠道采用率和 accounting 对 operations 始终可见。',
  'validation.required': '必填字段。',
  'validation.email': '请输入有效的电子邮箱。',
  'validation.minValue': '请输入有效的值。',
  'validation.fixErrors': '保存前请先修正高亮字段。',
  'validation.dateOrder': '结束日期必须晚于开始日期。',
  'validation.selectOne': '请至少选择一个元素。',
  'toast.dismiss': '关闭通知',
  'toast.error.network': '无法连接到后端服务。',
  'toast.error.badRequest': '请求无效。',
  'toast.error.unauthorized': '会话未授权。请重新登录。',
  'toast.error.forbidden': '你没有执行此操作所需的权限。',
  'toast.error.notFound': '未找到请求的资源。',
  'toast.error.conflict': '由于状态冲突，操作无法完成。',
  'toast.error.validation': '提交的数据无效。',
  'toast.error.server': '服务器返回了内部错误。',
  'toast.error.unavailable': '服务暂时不可用。',
  'toast.error.genericStatus': 'HTTP 错误 {status}：请求失败。',
  'toast.error.unexpected': 'HTTP 调用期间发生了意外错误。',
  'channel.tv': '电视',
  'channel.email': '邮件',
  'channel.dashboard': '控制台',
  'channel.print': '打印',
  'codeSource.pms': 'PMS',
  'codeSource.reception': '前台',
  'codeSource.bulk': '批量',
  'queueStatus.queued': '排队中',
  'queueStatus.running': '执行中',
  'queueStatus.completed': '已完成',
  'queueStatus.attention': '注意',
  'spaceKind.room': '客房',
  'spaceKind.public-area': '公共区域',
  'spaceKind.event-hall': '活动大厅',
  'assignment.room': '客房',
  'assignment.group': '分组',
  'assignment.common': '公共',
  'panMode.private': '私有',
  'panMode.shared-group': '共享分组',
  'panMode.public': '公共',
  'role.tv-integration': '电视集成',
  'role.platform-admin': 'Platform admin',
  'role.tenant-admin': '管理员',
  'role.reception': '礼宾员',
  'role.operations': 'Operations',
  'locationCategory.hotel': '酒店',
  'locationCategory.resort': '度假村',
  'locationCategory.conference': '会议场地',
  'locationState.active': '启用',
  'locationState.disabled': '停用',
  'locationState.pending': '待处理',
  'locationState.stable': '稳定',
  'locationState.attention': '注意',
  'unitStatus.available': '可用',
  'unitStatus.disabled': '已停用',
  'unitStatus.occupied': '占用中',
  'userStatus.active': '启用',
  'userStatus.invited': '已邀请',
  'userStatus.disabled': '已停用',
  'reception.tab.issue': '发放',
  'reception.tab.codes': '代码管理',
  'reception.tab.bulk': '批量上传',
  'reception.summary.active': '有效',
  'reception.summary.scheduled': '已计划',
  'reception.summary.archived': '已归档',
  'reception.summary.queue': '批量任务',
  'reception.issue.kicker': '手动发放',
  'reception.issue.title': '为住客和例外场景创建 DPSK',
  'reception.issue.description':
    '适用于 walk-in、供应商、酒吧接入或 PMS 回退。生成二维码和明文密码。',
  'reception.fields.firstName': '名',
  'reception.fields.lastName': '姓',
  'reception.fields.email': '邮箱',
  'reception.fields.space': '单元',
  'reception.fields.reference': '预订 / voucher 参考号',
  'reception.fields.validFrom': '生效时间',
  'reception.fields.validUntil': '失效时间',
  'reception.fields.devicesAllowed': '允许设备数',
  'reception.fields.deliveryChannels': '下发渠道',
  'reception.fields.notes': '操作员备注',
  'reception.preview.kicker': 'Voucher 预览',
  'reception.preview.title': '操作员卡片',
  'reception.preview.empty': '请选择一个单元以预览二维码。',
  'reception.preview.guest': '住客',
  'reception.preview.ssidVlan': 'SSID / VLAN',
  'reception.preview.panMode': 'PAN 模式',
  'reception.preview.expires': '过期时间',
  'reception.lastCreated': '最近创建的代码',
  'reception.lastCreatedEmpty': '生成一条手动 DPSK 后，这里会显示最新的 voucher 摘要。',
  'reception.generate': '生成 DPSK',
  'reception.creating': '正在生成...',
  'reception.codes.kicker': '代码管理',
  'reception.codes.title': '筛选、延长或撤销 voucher',
  'reception.filter.all': '全部',
  'reception.filter.pms': 'PMS',
  'reception.filter.reception': '前台',
  'reception.filter.bulk': '批量',
  'reception.searchPlaceholder': '搜索住客或参考号',
  'reception.activeList': '有效 / 已计划',
  'reception.archivedList': '已归档 / 无效',
  'reception.actions.extend': '+24h',
  'reception.actions.revoke': '撤销',
  'reception.actions.new': '新建 DPSK',
  'reception.actions.backToCodes': '返回代码列表',
  'reception.actions.showQr': '查看 QR',
  'reception.actions.printQr': '打印 QR',
  'reception.confirm.extend': '将 {name} 的 voucher 延长 24 小时？',
  'reception.confirm.revoke': '撤销 {name} 的 voucher？',
  'reception.activeEmpty': '当前筛选条件下没有有效或已计划的代码。',
  'reception.archivedEmpty': '当前筛选条件下没有已归档或已撤销的代码。',
  'reception.bulk.kicker': '批量接入',
  'reception.bulk.title': '面向群组和活动的 CSV 导入',
  'reception.bulk.loadFile': '加载文件',
  'reception.bulk.mode': '批量模式',
  'reception.bulk.modeShared': '共享组 VLAN',
  'reception.bulk.modeIsolated': '按单元 VLAN / 隔离',
  'reception.bulk.defaultSpace': '默认单元',
  'reception.bulk.requestedBy': '申请人',
  'reception.bulk.csvBody': 'CSV 内容',
  'reception.bulk.queue': '将导入加入队列',
  'reception.bulk.queueing': '正在加入队列...',
  'reception.bulk.templateHint':
    '期望列：firstName, lastName, email, spaceId, validFrom, validUntil, devicesAllowed, bookingReference',
  'reception.bulk.jobs': '队列状态',
  'reception.bulk.jobsTitle': '最近活动',
  'reception.emptyLocation': '请选择或创建一个包含可用单元的地点。',
  'reception.message.created': '已为 {name} 创建 {id}。',
  'reception.message.bulkQueued': '任务 {id} 已加入队列，包含 {imported} 个身份（{status}）。',
  'reception.message.extended': '{id} 的有效期已延长 24 小时。',
  'reception.message.revoked': '代码 {id} 已撤销。',
  'admin.vendorHintTitle': 'Vendor 目录',
  'admin.vendorHintBody':
    '在创建或更新地点前，可以先登记控制器和 PMS 的 vendor 目录，这样地点表单中的下拉菜单和配置字段就会准备就绪。',
  'admin.card.tenants.label': '租户',
  'admin.card.tenants.caption': '在面板中管理的多租户组合',
  'admin.card.locations.label': '地点',
  'admin.card.locations.caption': '原型中可用的酒店、度假村和场馆',
  'admin.card.users.label': '用户',
  'admin.card.users.caption': '通过 mock 状态管理的运营角色和分配',
  'admin.card.spaces.label': '单元 / VLAN',
  'admin.card.spaces.caption': '所选地点当前的单元清单',
  'admin.tab.tenants': '租户',
  'admin.tab.locations': '地点',
  'admin.tab.users': '用户',
  'admin.tab.controllerVendors': '控制器 vendor',
  'admin.tab.pmsVendors': 'PMS vendor',
  'admin.tab.infrastructure': '基础设施',
  'admin.tenants.kicker': '租户管理',
  'admin.tenants.title': '创建并更新租户',
  'admin.locations.kicker': '地点管理',
  'admin.locations.title': '管理酒店、度假村和场馆',
  'admin.locations.filterHint':
    '选择一个租户以仅显示其相关地点，而不使用全局运营筛选器。',
  'admin.users.kicker': '用户管理',
  'admin.users.title': '角色、租户范围和地点范围',
  'admin.controllerVendors.kicker': '控制器目录',
  'admin.controllerVendors.title': '登记并管理控制器 vendor',
  'admin.controllerVendors.empty': '尚未登记任何控制器 vendor。',
  'admin.controllerVendors.emptyHint':
    '添加第一个控制器 vendor，以便在地点接入时可选。',
  'admin.pmsVendors.kicker': 'PMS 目录',
  'admin.pmsVendors.title': '登记并管理 PMS vendor',
  'admin.pmsVendors.empty': '尚未登记任何 PMS vendor。',
  'admin.pmsVendors.emptyHint':
    '添加第一个 PMS vendor，以便在地点接入时可选。',
  'admin.infrastructure.kicker': '清单与集成',
  'admin.infrastructure.title': '单元、VLAN 与连接器就绪状态',
  'admin.form.new': '新建',
  'admin.form.reset': '重置',
  'admin.form.create': '创建',
  'admin.form.update': '更新',
  'admin.form.name': '名称',
  'admin.form.brand': '品牌 / 描述',
  'admin.form.sla': 'SLA',
  'admin.form.coverage': 'DPSK 覆盖率 %',
  'admin.form.city': '城市',
  'admin.form.category': '类别',
  'admin.form.pms': 'PMS',
  'admin.form.pmsVendor': 'PMS vendor',
  'admin.form.pds': 'PDS 配置',
  'admin.form.controller': '控制器',
  'admin.form.controllerVendor': '控制器 vendor',
  'admin.form.tv': '电视集成',
  'admin.form.email': '邮件集成',
  'admin.form.integrations': '集成',
  'admin.form.state': '状态',
  'admin.form.dailyCheckIns': '每日 check-in',
  'admin.form.activeGuests': '在住宾客',
  'admin.form.bulkQueue': '批量队列',
  'admin.form.note': '运营备注',
  'admin.form.timezone': '时区',
  'admin.form.linkedTenant': '关联租户',
  'admin.form.role': '角色',
  'admin.form.status': '用户状态',
  'admin.form.tenantScope': '租户范围',
  'admin.form.locationScope': '地点范围',
  'admin.form.fieldSchema': '字段结构',
  'admin.form.fieldName': '字段名',
  'admin.form.fieldType': '字段类型',
  'admin.form.fieldsHelp': '请至少为 vendor 定义一个额外字段。',
  'admin.form.selectVendor': '选择 vendor',
  'admin.form.selectVendorFirst': '请先选择 vendor，再配置必填字段。',
  'admin.form.pmsConfiguration': 'PMS 配置',
  'admin.form.controllerConfiguration': '控制器配置',
  'admin.form.vendorConfigurationHint':
    '请填写所选 vendor 目录条目要求的全部字段。',
  'admin.form.noPmsVendorsAvailable':
    '尚无可用 PMS vendor。请先登记 PMS 目录。',
  'admin.form.noControllerVendorsAvailable':
    '尚无可用控制器 vendor。请先登记控制器目录。',
  'admin.form.addField': '添加字段',
  'admin.form.removeField': '删除字段',
  'admin.form.createControllerVendor': '创建控制器 vendor',
  'admin.form.createPmsVendor': '创建 PMS vendor',
  'admin.form.updateControllerVendor': '更新控制器 vendor',
  'admin.form.updatePmsVendor': '更新 PMS vendor',
  'admin.form.controllerVendorNotFound': '未找到控制器 vendor。',
  'admin.form.pmsVendorNotFound': '未找到 PMS vendor。',
  'admin.form.vendorFieldType.string': '字符串',
  'admin.form.vendorFieldType.number': '数字',
  'admin.form.vendorFieldType.boolean': '布尔',
  'admin.form.vendorFieldType.password': '密码',
  'admin.form.unitType': '单元类型',
  'admin.form.assignment': '分配方式',
  'admin.form.unitStatus': '单元状态',
  'admin.list.portfolio': '组合',
  'admin.list.properties': '资产',
  'admin.list.coverage': '覆盖率',
  'admin.list.alerts': '告警',
  'admin.list.noneTenants': '尚未登记任何租户。',
  'admin.list.noneLocations': '所选租户下没有可用地点。',
  'admin.tenants.emptyHint': '创建第一个租户以开始平台的多租户接入。',
  'admin.actions.edit': '编辑',
  'admin.actions.toggleStatus': '切换状态',
  'admin.actions.newTenant': '新建租户',
  'admin.actions.newLocation': '新建地点',
  'admin.actions.newUser': '新建用户',
  'admin.actions.newControllerVendor': '新建控制器 vendor',
  'admin.actions.newPmsVendor': '新建 PMS vendor',
  'admin.actions.manageInfrastructure': '基础设施',
  'admin.actions.backToLocation': '返回地点',
  'admin.actions.backToList': '返回列表',
  'admin.actions.delete': '删除',
  'admin.infrastructure.inventory': '单元清单',
  'admin.infrastructure.roomAssignments': '单房分配',
  'admin.infrastructure.roomAssignmentsDesc':
    '每个房间都会单独映射 SSID、VLAN 和 PAN 模式。使用此区域为单个房间创建或修正分配。',
  'admin.infrastructure.locationScopeDesc':
    '此页面属于所选地点。基础设施分配直接在地点内管理。',
  'admin.infrastructure.sharedSpaces': '共享单元和活动厅',
  'admin.infrastructure.noRooms': '所选地点尚未配置房间。',
  'admin.infrastructure.noSharedSpaces': '尚未配置共享单元。',
  'admin.infrastructure.roomPreview': '分配预览',
  'admin.infrastructure.readiness': '集成就绪度',
  'admin.integrations.queuePlaceholder': 'Redis / RabbitMQ 由后端确定',
  'admin.integrations.pdsPlaceholder': 'PDS 配置待定义',
  'admin.form.createTenant': '创建租户',
  'admin.form.updateTenant': '更新租户',
  'admin.form.tenantNotFound': '未找到租户。',
  'admin.form.createLocation': '创建地点',
  'admin.form.updateLocation': '更新地点',
  'admin.form.locationNotFound': '未找到地点。',
  'admin.form.createUser': '创建用户',
  'admin.form.updateUser': '更新用户',
  'admin.form.userNotFound': '未找到用户。',
  'admin.form.roomName': '房间',
  'admin.form.ssid': 'SSID',
  'admin.form.vlanId': 'VLAN',
  'admin.form.serviceVlanId': '服务 VLAN',
  'admin.form.networkId': '网络 ID',
  'admin.form.capacity': '容量',
  'admin.message.tenantSaved': '租户 {name} 已保存。',
  'admin.message.tenantDeleted': '租户 {name} 已删除。',
  'admin.message.locationSaved': '地点 {name} 已保存。',
  'admin.message.locationDeleted': '地点 {name} 已删除。',
  'admin.message.userSaved': '用户 {name} 已保存。',
  'admin.message.userDeleted': '用户 {name} 已删除。',
  'admin.message.controllerVendorSaved': '控制器 vendor {name} 已创建。',
  'admin.message.pmsVendorSaved': 'PMS vendor {name} 已创建。',
  'admin.message.controllerVendorUpdated': '控制器 vendor {name} 已更新。',
  'admin.message.pmsVendorUpdated': 'PMS vendor {name} 已更新。',
  'admin.message.controllerVendorDeleted': '控制器 vendor {name} 已删除。',
  'admin.message.pmsVendorDeleted': 'PMS vendor {name} 已删除。',
  'admin.message.roomDeleted': '房间 {name} 已删除。',
  'admin.confirm.deleteTenant': '删除租户 {name} 以及其所有关联地点？',
  'admin.confirm.deleteLocation': '删除地点 {name} 及其基础设施？',
  'admin.confirm.deleteUser': '删除用户 {name}？',
  'admin.confirm.deleteRoom': '删除房间 {name}？',
  'admin.confirm.deleteControllerVendor': '删除控制器 vendor {name}？',
  'admin.confirm.deletePmsVendor': '删除 PMS vendor {name}？',
  'reception.tab.events': '活动',
  'reception.actions.sendEmail': '通过电子邮件发送',
  'reception.message.emailed': '代码 {id} 已通过电子邮件发送。',
  'events.kicker': '活动 Wi-Fi',
  'events.title': '创建和管理活动访问',
  'events.name': '活动名称',
  'events.hall': '活动厅',
  'events.duration': '持续时间',
  'events.code': '活动代码',
  'events.isolation': '客户端隔离',
  'events.network.loading': '正在加载网络...',
  'events.network.empty': '没有可用的网络',
  'events.network.loadError': '无法加载网络',
  'events.isolated': '已隔离',
  'events.shared': '共享访问',
  'events.policy': '策略',
  'events.contactName': '联系人姓名',
  'events.create': '新建活动',
  'events.edit': '编辑活动',
  'events.sendEmail': '通过电子邮件发送代码',
  'events.disable': '停用活动',
  'events.empty': '此地点尚未配置任何活动。',
  'reception.tab.hotel': '酒店', 'reception.hotel.description': '由 PMS 或礼宾员管理客房和公共区域代码', 'reception.hotel.kicker': '酒店 Wi-Fi 代码', 'reception.hotel.title': '管理客房和公共区域访问代码',
  'admin.onboarding.kicker': '地点引导式登记', 'admin.onboarding.title': '创建并配置新地点', 'admin.onboarding.description': '请按规定顺序完成从供应商到 Lumen 的交接。',
  'admin.onboarding.step1': '控制器', 'admin.onboarding.step2': '地点', 'admin.onboarding.step3': '集成', 'admin.onboarding.step4': '审核', 'admin.onboarding.step5': '审核',
  'admin.onboarding.locationKicker': '步骤 2 · 地点信息', 'admin.onboarding.locationTitle': '输入新地点信息',
  'admin.onboarding.controllerKicker': '步骤 1 · 供应商连接', 'admin.onboarding.controllerTitle': '配置地点控制器', 'admin.onboarding.controllerHelp': '硬件、射频、AP 组和基础 SSID 必须已在供应商平台配置。',
  'admin.onboarding.integrationsKicker': '步骤 3 · 可选集成', 'admin.onboarding.integrationsTitle': '配置 PMS、电视和电子邮件', 'admin.onboarding.reviewKicker': '步骤 4 · 审核', 'admin.onboarding.reviewTitle': '确认地点配置', 'admin.onboarding.unitsNext': '保存后，请配置客房、共享单元和活动厅的 VLAN 与网络映射。', 'admin.onboarding.saveContinue': '保存并配置单元',
  'reception.fields.selectSpace': '选择单元',
  'reception.category.journalist': '记者',
  'reception.category.relator': '演讲者',
  'reception.categoryDescription.staff': '代码将在预设 VLAN 上创建。',
  'reception.categoryDescription.iot': '代码将在预设 VLAN 上创建。',
  'reception.categoryDescription.visitor': '代码将在预设 VLAN 上创建。',
  'reception.categoryDescription.guest': '请选择客房以关联其 VLAN。',
  'events.message.saved': '活动 {name} 已保存。',
  'events.message.emailSent': '活动代码已发送至 {email}。',
  'events.message.disabled': '活动 {name} 已停用。',
  'events.codes.kicker': '宾客与访客管理',
  'events.codes.manage': '管理活动代码',
  'events.codes.type': '代码类型',
  'events.codes.mode': '创建方式',
  'events.codes.personal': '个人',
  'events.codes.manual': '手动',
  'events.codes.bulk': '批量导入',
  'events.codes.personalManual': '个人 · 手动',
  'events.codes.personalBulk': '个人 · 批量导入',
  'events.codes.group': '群组',
  'events.codes.manualTitle': '创建个人代码',
  'events.codes.bulkTitle': '从 CSV 导入个人代码',
  'events.codes.groupTitle': '创建群组代码',
  'events.codes.groupName': '群组名称',
  'events.codes.sendEmail': '通过电子邮件发送代码',
  'events.codes.service': '服务',
  'events.codes.serviceHint': '使用为活动厅配置的服务 VLAN。',
  'events.codes.serviceUnavailable': '所选活动厅未配置服务 VLAN。',
  'events.codes.bulkHint': '必填列：firstName、lastName、email、category、devicesAllowed。时长和活动厅继承自活动；处理任务将进入队列，以遵守供应商的请求速率限制。',
  'events.codes.createPersonal': '创建个人代码',
  'events.codes.createGroup': '创建群组代码',
  'events.codes.queueBulk': '将 CSV 导入加入队列',
  'events.codes.personalCreated': '个人代码已创建：{code}',
  'events.codes.groupCreated': '群组代码已创建：{code}',
  'events.codes.bulkQueued': '导入任务 {id} 已加入队列：已处理 {imported} 个代码。',
  'admin.unitsBulk.action': '批量导入',
  'admin.unitsBulk.kicker': '批量导入单元',
  'admin.unitsBulk.title': '从 CSV 导入单元',
  'admin.unitsBulk.description': '一次创建客房、共享区域和活动厅。',
  'admin.unitsBulk.loadFile': '加载 CSV',
  'admin.unitsBulk.csv': '单元 CSV',
  'admin.unitsBulk.hint': '列：name、type、vlanId、serviceVlanId、networkId、panMode、capacity、assignment、status。必填：name、type、vlanId、networkId。',
  'admin.unitsBulk.importing': '正在导入...',
  'admin.unitsBulk.import': '导入单元',
  'admin.unitsBulk.completed': '已导入 {count} 个单元。',
  'admin.unitsBulk.invalid': 'CSV 无效：{error}',
  'admin.unitsBulk.noRows': '未找到数据行。',
  'admin.unitsBulk.missingColumns': '缺少列：{columns}。',
  'admin.unitsBulk.rowError': '第 {row} 行的值无效。',
};
